import { useNavigate } from "react-router-dom";

import {
  PrecipTrackSample,
  ThunderLadderSample,
  TintRampSample,
  WindSparklineSample,
} from "../components/help/TimelineLegendSample";
import { PageShell } from "../components/PageShell";
import { PRECIP_BASE } from "../lib/timelineTint";

export default function TimelineHelpPage() {
  const navigate = useNavigate();

  return (
    <PageShell className="min-h-dvh">
      <button
        type="button"
        onClick={() => navigate(-1)}
        aria-label="Back"
        className="mb-4 text-[14px] text-primary"
      >
        ← Back
      </button>

      <h1 className="mb-6 text-[24px] font-bold">Reading the timeline</h1>

      <section className="mb-6 flex flex-col gap-2">
        <h2 className="text-[16px] font-medium">Precipitation bars</h2>
        <p className="text-[14px] text-on-surface-variant">
          Green, blue, and pink bars show rain, snow, and ice chances through the day. Darker
          segments mean higher probability. On dry days the track stays visible as a neutral gray
          bar with no colored fill.
        </p>
        <TintRampSample />
        <PrecipTrackSample color={PRECIP_BASE.rain} />
        <PrecipTrackSample color={PRECIP_BASE.snow} />
        <PrecipTrackSample color={PRECIP_BASE.ice} />
      </section>

      <section className="mb-6 flex flex-col gap-2">
        <h2 className="text-[16px] font-medium">Storm dots</h2>
        <p className="text-[14px] text-on-surface-variant">
          Red dots above the bar mark hours with meaningful thunder risk (15% or higher). Dot size
          and color intensify as probability increases.
        </p>
        <ThunderLadderSample />
      </section>

      <section className="mb-6 flex flex-col gap-2">
        <h2 className="text-[16px] font-medium">Time labels</h2>
        <p className="text-[14px] text-on-surface-variant">
          Labels sit directly under the precipitation bar, from 6 AM through midnight local time.
        </p>
        <div className="flex w-48 justify-between text-[11px] text-on-surface-variant">
          <span>6a</span>
          <span>10a</span>
          <span>2p</span>
          <span>6p</span>
          <span>10p</span>
          <span>12a</span>
        </div>
      </section>

      <section className="mb-6 flex flex-col gap-2">
        <h2 className="text-[16px] font-medium">Wind sparkline</h2>
        <p className="text-[14px] text-on-surface-variant">
          Below the time labels, a compact sparkline shows sustained wind (steel line). An amber
          dashed gust line appears only when gusts are strong enough to matter (at least 22 mph, or
          noticeably higher than sustained wind). Day-max speeds are summarized in one line below
          the plot.
        </p>
        <WindSparklineSample />
        <p className="text-center text-[9px] text-on-surface-variant">18 mph · gust 28</p>
      </section>

      <section className="flex flex-col gap-2">
        <h2 className="text-[16px] font-medium">Full day detail</h2>
        <p className="text-[14px] text-on-surface-variant">
          Tap a day card to open the full 24-hour breakdown with hourly temperatures and conditions.
        </p>
      </section>
    </PageShell>
  );
}
